import PropTypes from 'prop-types';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { config } from 'src/config/wagmiConfig';

const queryClient = new QueryClient();

export function AppProviders({ children, reconnectOnMount = true }) {
  return (
    <WagmiProvider config={config} reconnectOnMount={reconnectOnMount}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  );
}

AppProviders.propTypes = {
  children: PropTypes.node,
  reconnectOnMount: PropTypes.bool,
};
